import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Col, Form, Input } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { quoteCommentsInitialValues, validationSchema } from './constants';

const QuoteComments = forwardRef(({ data, onDataChange }, ref) => {
  const {
    control,
    setValue,
    watch,
    trigger,
    getValues,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: quoteCommentsInitialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    shouldUnregister: false,
  });

  useImperativeHandle(ref, () => ({
    triggerAll: () => trigger(),
    triggerFields: names => trigger(names),
    getValues: () => getValues(),
    hasErrors: () => Object.keys(errors || {}).length > 0,
    focusFirstError: () => {
      const first = Object.keys(errors || {})[0];
      if (first) setFocus(first);
    },
  }));

  useEffect(() => {
    if (!data) return;
    // Note: backend key seems to be "QuoteCommets" (typo). Keep as-is if that's what you receive.
    if (data.QuoteCommets != null) {
      setValue('quoteComments', data.QuoteCommets || '');
    }
  }, [data, setValue]);

  const watched = watch();
  useEffect(() => {
    onDataChange?.(watched);
  }, [watched, onDataChange]);

  return (
    <div className="ba-form d-flex flex-column gap-2">
      <div>
        <span className="fw-semibold">
          <span>Quote Comments</span>
          <span className="text-danger-tr">*</span>
        </span>
      </div>
      <Form className="d-flex flex-row gap-2">
        <Col className="external-filter-col">
          <Controller
            control={control}
            name="quoteComments"
            render={({ field }) => (
              <Input
                className={`external-filter-input ${errors.quoteComments ? 'is-invalid' : ''}`}
                {...field}
                placeholder="Quote Comments"
                type="textarea"
              />
            )}
          />
          {errors.quoteComments && (
            <span className="text-danger-tr">
              {errors.quoteComments.message || 'Quote comments are required'}
            </span>
          )}
        </Col>
      </Form>
    </div>
  );
});

export default QuoteComments;
